import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { Common } from "components";
import { useTheme } from "contexts";
import { Helpers } from "utils";

type Props = {};

export const Home = (props: Props) => {
  const { theme } = useTheme();

  return (
    <Box pt={theme.spacing.sm}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Common.Intro />
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{ display: { xs: "none", md: "unset" } }}
            >
              <Common.Image src={Helpers.getImage("homepage_art.png")} />
            </Grid>
          </Grid>
        </Container>
        <Common.Footnote />
      </Stack>
    </Box>
  );
};
